<div class="chuongtrinhkhuyenmai">
  <div class="content-heading">
    <span class="title-page">{{'Chương trình khuyến mại' | translate}}</span>
    <div class="full-right">
      <button *ngIf="quyen_them" (click)="openAddModal()" class="btn btn-primary" style="margin-right:15px;">
        <em class="mr-2 fa fa-plus"></em>{{'Thêm mới' | translate}}
      </button>
      <div class="btn-group mb-1 mr-1" dropdown>
        <button class="btn dropdown-toggle btn-info" type="button" dropdownToggle>
          <i class="fas fa-cog"></i>
          {{'Tiện ích' | translate}}
        </button>
        <div *dropdownMenu class="dropdown-menu" role="menu">
          <a class="dropdown-item" *ngIf="quyen_sua" (click)="openEditModal()">
            <i class="fas fa-edit mr-2"></i>{{'Sửa' | translate}}
          </a>
          <a class="dropdown-item" *ngIf="quyen_xoa" (click)="deleteVoucher()">
            <i class="fas fa-trash mr-2"></i>{{'Xóa' | translate}}
          </a>
          <a class="dropdown-item" (click)="refreshData()">
            <i class="fas fa-sync-alt mr-2"></i>{{'Làm mới' | translate}}
          </a>
        </div>
      </div>
      <div class="site-search">
        <input type="text" [(ngModel)]="TimKiems.NoiDung" (keydown)="onKeydownEvent($event)"
               placeholder="Tìm kiếm..." class="form-control" autocomplete="off">
      </div>
    </div>
  </div>

  <!-- Data table -->
  <div class="row" style="margin-left: 0px; margin-top: 10px; overflow: auto; width: 100%">
    <div style="padding: 0px; color: black !important; height: calc(100vh - 180px); width: 100%;">
      <table id="fixTable" class="table table-striped table-bordered table-hover table-condensed">
        <thead>
          <tr class="thCenter">
            <th style="min-width:50px;text-align:center;background-color:#f3f8fc">STT</th>
            <th style="min-width:50px;text-align:center;background-color:#f3f8fc">Active</th>
            <th style="min-width:200px;text-align:center;background-color:#f3f8fc">
              {{'Nội dung' | translate}}
            </th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">
              {{'Từ ngày' | translate}}
            </th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">
              {{'Đến ngày' | translate}}
            </th>
            <th style="min-width:150px;text-align:center;background-color:#f3f8fc">
              {{'Số tiền giảm' | translate}}
            </th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">
              {{'Loại áp dụng' | translate}}
            </th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">
              {{'Trạng thái' | translate}}
            </th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">
              {{'Người sửa' | translate}}
            </th>
            <th style="min-width:140px;text-align:center;background-color:#f3f8fc">
              {{'Ngày sửa' | translate}}
            </th>
          </tr>
          <tr class="filter-row">
            <td style="background-color:#f3f8fc"></td>
            <td style="background-color:#f3f8fc"></td>
            <td style="background-color:#f3f8fc">
              <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                     [(ngModel)]="TimKiems.NoiDung" placeholder="{{'Gõ nội dung tìm kiếm và ấn Enter' | translate}}"
                     (keydown)="onKeydownEvent($event)" autocomplete="off">
            </td>
            <td style="background-color:#f3f8fc">
              <kendo-dateinput style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="ngayTimKiemTu"
                               (keydown)="onKeydownEvent($event)"></kendo-dateinput>
            </td>
            <td style="background-color:#f3f8fc">
              <kendo-dateinput style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="ngayTimKiemDen"
                               (keydown)="onKeydownEvent($event)"></kendo-dateinput>
            </td>
            <td style="background-color:#f3f8fc">
              <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                     [(ngModel)]="TimKiems.SoTienGiam" placeholder="{{'Tìm kiếm' | translate}}"
                     (keydown)="onKeydownEvent($event)" autocomplete="off">
            </td>
            <td style="background-color:#f3f8fc">
              <select class="form-control" style="height:22px !important" [(ngModel)]="TimKiems.LoaiApDung"
                      (change)="onKeydownEvent($event)">
                <option value="">{{'Tất cả' | translate}}</option>
                <option *ngFor="let item of loaiApDungOptions" [value]="item.id">{{item.name}}</option>
              </select>
            </td>
            <td style="background-color:#f3f8fc">
              <div class="btn-group mb-1 mr-1" dropdown>
                <button class="btn dropdown-toggle btn-add" type="button" dropdownToggle>
                  <i class="fa fa-filter"></i>
                  {{'Lọc' | translate}}
                </button>
                <div *dropdownMenu class="dropdown-menu" role="menu">
                  <a class="dropdown-item" (click)="filterByStatus(true)">{{'Hoạt động' | translate}}</a>
                  <a class="dropdown-item" (click)="filterByStatus(false)">{{'Không hoạt động' | translate}}</a>
                  <a class="dropdown-item" (click)="clearFilters()">{{'Xóa lọc' | translate}}</a>
                </div>
              </div>
            </td>
            <td style="background-color:#f3f8fc">
              <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                     [(ngModel)]="TimKiems.NguoiSua" placeholder="{{'Tìm kiếm' | translate}}"
                     (keydown)="onKeydownEvent($event)" autocomplete="off">
            </td>
            <td style="background-color:#f3f8fc"></td>
          </tr>
        </thead>
        <tbody style="max-height:calc(100vh - 200px);">
          <tr *ngFor="let u of datas; let i = index" [ngClass]="{'rowItem_Selected': u.Id === selectedId}"
              (click)="selectRow(u)">
            <td style="width:50px;text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              {{ i + 1 }}
            </td>
            <td style="width:50px;text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <div class="x-grid-cell-inner" style="text-align: center;">
                <img *ngIf="u.HoatDong" style="width: 20px;" src="../assets/img/active.png">
                <img *ngIf="!u.HoatDong" style="width: 20px;" src="../assets/img/stop.png">
              </div>
            </td>
            <td style="text-align:left" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">{{u.NoiDung}}</a>
            </td>
            <td style="text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">{{u.TuNgay | date: 'dd/MM/yyyy'}}</a>
            </td>
            <td style="text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">{{u.DenNgay | date: 'dd/MM/yyyy'}}</a>
            </td>
            <td style="text-align:right;font-weight:bold;color:red" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">
                {{u.SoTienGiam | number}}
                <span *ngIf="u.SoTienGiam <= 100" style="font-size:11px;color:blue">%</span>
                <span *ngIf="u.SoTienGiam > 100" style="font-size:11px;color:green">đ</span>
              </a>
            </td>
            <td style="text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">{{getLoaiApDungText(u.LoaiApDung)}}</a>
            </td>
            <td style="text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <span class="badge" [ngClass]="u.HoatDong ? 'badge-success' : 'badge-secondary'">
                {{u.HoatDong ? 'Hoạt động' : 'Không hoạt động'}}
              </span>
            </td>
            <td style="text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">{{u.ModifiedBy}}</a>
            </td>
            <td style="text-align:center" [ngClass]="{'rowItem_Selected': u.Id === selectedId}">
              <a (dblclick)="openEditModal()">{{u.Modified | date: 'dd/MM/yyyy HH:mm:ss'}}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination -->
  <div style="width:100%">
    <div>
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled: currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li [ngClass]="{disabled: currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li><span style="font-weight:bold">{{'Tổng' | translate}}: {{totalItems | number}}</span></li>
        <li>
          <input type="number" style="width:50px;height:23px;text-align:center"
                 [(ngModel)]="pageSize" (blur)="onBlur()" />
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Add/Edit Modal -->
<bs-modal #mdThemKhuyenMai class="modal fade show in" [cssClass]="'modal8'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="closeModal()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <div class="container-fluid">
      <div class="row form-group">
        <label class="control-label col-3">Nội dung <span class="required">(*)</span></label>
        <div class="col-9">
          <input type="text" class="form-control" [(ngModel)]="newVoucher.NoiDung"
                 placeholder="Nhập nội dung chương trình khuyến mại" maxlength="200">
        </div>
      </div>

      <div class="row form-group">
        <label class="control-label col-3">Từ ngày <span class="required">(*)</span></label>
        <div class="col-4">
          <kendo-dateinput style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="newVoucher.TuNgay"></kendo-dateinput>
        </div>
        <label class="control-label col-2">Đến ngày <span class="required">(*)</span></label>
        <div class="col-3">
          <kendo-dateinput style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="newVoucher.DenNgay"></kendo-dateinput>
        </div>
      </div>

      <div class="row form-group">
        <label class="control-label col-3">Số tiền hoặc % giảm <span class="required">(*)</span></label>
        <div class="col-6">
          <input class="form-control" currencyMask [(ngModel)]="newVoucher.SoTienGiam"
                 [options]="ngxCurrencyOptions" placeholder="Nhập số tiền giảm hoặc phần trăm giảm">
        </div>
        <div class="col-3">
          <small class="form-text text-muted">
            Nếu ≤100: tính theo %, >100: tính theo số tiền
          </small>
        </div>
      </div>
      <div class="row form-group">
        <label class="control-label col-3">Lớp học <span class="required">(*)</span></label>
        <div class="col-6">
          <ng-select #slLop
                     class="twcollong"
                     [tabIndex]="26"
                     [multiple]="false"
                     [openOnEnter]="false"
                     [items]="danhSachLop"
                     bindValue="Id"
                     bindLabel="Ten"
                     notFoundText="Không có dữ liệu"
                     [(ngModel)]="newVoucher.LopId">
            <ng-template ng-option-tmp let-item="item">
              <div class="rTableRow">
                <div class="rTableCell_1">{{item.Ten}}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-3">
          <small class="form-text text-muted">
            Chọn lớp học áp dụng chương trình khuyến mại
          </small>
        </div>
      </div> 
      <div class="row form-group">
        <label class="control-label col-3">Loại áp dụng <span class="required">(*)</span></label>
        <div class="col-6">
          <select class="form-control" [(ngModel)]="newVoucher.LoaiApDung" required>
            <option value="">{{'Chọn loại áp dụng' | translate}}</option>
            <option *ngFor="let item of loaiApDungOptions" [value]="item.id">{{item.name}}</option>
          </select>
        </div>
        <div class="col-3">
          <small class="form-text text-muted">
            Chọn cách thức áp dụng chương trình khuyến mại
          </small>
        </div>
      </div>

      <div class="row form-group">
       
        <div class="col-6">
          <div class="checkbox c-checkbox">
            <label>
              <input type="checkbox" [(ngModel)]="newVoucher.HoatDong" />
              <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
            </label>
          </div>
        </div>
        <div class="col-6">
          <div class="checkbox c-checkbox">
            <label>
              <input type="checkbox" [(ngModel)]="newVoucher.IsSum" />
              <span class="fa fa-check"></span> Giảm trừ tổng tiền
            </label>
          </div>
        </div>
      </div>
    </div>
  </bs-modal-body>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">{{'Hủy bỏ' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="saveVoucher()">{{'Lưu lại' | translate}}</button>
  </div>
</bs-modal>
